
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/congres-infok",
      function () {
        return require("private-next-pages/corporatiu/congres-infok/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/congres-infok"])
      });
    }
  